import type { TFunction } from 'i18next'

import type { KycSection } from './formLayout'

/**
 * The line under the title on one page. The title itself never changes, so
 * this is what says which details the page is asking for.
 *
 * Client copy, read off the frames: 1508:2616, 1844:17471, 1631:7256,
 * 1631:7883.
 */
export function sectionDetail(section: KycSection, t: TFunction): string {
  switch (section) {
    case 'NAME':
      return t('fiat.kycDetailName')
    case 'DOB':
      return t('fiat.kycDetailDob')
    case 'NATIONALITY':
      return t('fiat.kycDetailNationality')
    case 'COUNTRY':
      return t('fiat.kycDetailCountry')
    case 'OCCUPATION':
      return t('fiat.kycDetailOccupation')
    case 'PURPOSE':
      return t('fiat.kycDetailPurpose')
    case 'ADDRESS':
      return t('fiat.kycDetailAddress')
    case 'SSN':
      return t('fiat.kycDetailSsn')
    case 'PHONE':
      return t('fiat.kycDetailPhone')
    case 'EMPLOYMENT':
      return t('fiat.kycDetailEmployment')
    case 'SOURCE_OF_WEALTH':
      return t('fiat.kycDetailSourceOfWealth')
    case 'INCOME':
      return t('fiat.kycDetailIncome')
    case 'ACTIVITY':
      return t('fiat.kycDetailActivity')
    case 'DETAILS':
      return t('fiat.kycDetailOther')
  }
}
